export default function getInitialLettersOfName(name: string): string {
  const names = name.split(' ');

  const [firstName] = names;

  const firstLetterFirstName = firstName.substring(0, 1);

  let firstLetterLastName = '';

  if (names.length > 1) {
    firstLetterLastName = names[names.length - 1].substring(0, 1);
  }

  return `${firstLetterFirstName.toUpperCase()}${firstLetterLastName.toUpperCase()}`;
}
